module.exports = __webpack_public_path__ + "productivity2.webp?f363e4f82ac6b1f9d5b7bf39530e0c90";